/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
* Recipe post - Color for bottom text
* */
function setTextColor() {
  let footer = document.querySelector('[data-recipe-footer]');

  if(!footer) return;

  let footerOffsetTop = footer.getBoundingClientRect().top;

  let spanElements = document.querySelectorAll('[data-recipe-span]');
  let spanParentElements = document.querySelectorAll('[data-span-parent]');

  spanElements.forEach(function (el) {
    let spanParent = el.parentNode.parentNode;
    let spanOffsetTop = el.getBoundingClientRect().top + 15;

    if(spanOffsetTop < footerOffsetTop) {
      spanParent.classList.remove('inverse')
      el.classList.remove('inverse')
    } else {
      spanParent.classList.add('inverse')
      el.classList.add('inverse')
    }
  })

  spanParentElements.forEach(function (el) {
    let span = el.querySelector('span');

    if(!span.classList.contains('inverse')) {
      el.classList.remove('inverse');
    }
  })
}

window.addEventListener('load', function () {
  setTimeout(setTextColor, 1000)
})

window.addEventListener('resize', function () {
  setTextColor();
})





// Bon widget translations.

document.addEventListener("DOMContentLoaded", function() {

    var iframe = document.getElementById('bon-app-iframe');
    var langValue = document.documentElement.lang;
    var loyaltyBtn = document.getElementById('bon-loyalty-btn')
    var loyaltyBtnText = loyaltyBtn.querySelector('span')



  

    if ( langValue === 'en' ) {
      loyaltyBtnText.textContent='Rewards'
    } else if ( langValue === 'de' ) {
      loyaltyBtnText.textContent='Belohnung'
    }
  
    if (iframe) {

        var currentContentSrc = iframe.getAttribute('content-src');
        var newContentSrc = currentContentSrc.replace(/(lang=)[^&]+/, '$1' + langValue);
       
        iframe.setAttribute('content-src', newContentSrc);
    }
});


// Change text content of the element in search results

setTimeout(() => {
  const element = document.querySelector('.boost-sd__fallback-empty-product');

  if (element) {
      element.textContent = 'Keine Produkte gefunden';
      console.log('test')
  }
}, 130);
